// src/App.js
import React, { useEffect } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

import Header from "./Layouts/Header/Header";
import Footer from "./Layouts/Footer/Footer";
import Home from "./Pages/Home";
import AboutSection from "./Pages/About";
import BlogCards from "./Pages/Blogs";
import RecruitmentPage from "./Pages/Recruitment";
import OrganizationPage from "./Pages/OrganizationPage";
import LearningDevelopmentPage from "./Pages/LearningDevelopmentPage";
import AOS from "aos";
import "aos/dist/aos.css";
import HrOutsourcingPage from "./Pages/HrOutsourcingPage";
import JobseekerBlog from "./Pages/JobseekerBlog";
import Testimonials from "./Pages/jobseekers-reviews";
import JobseekersProgram from "./Pages/JobseekersProgram";
import RemoteProgram from "./Pages/RemoteProgram";
import HireOnProSapiens from "./Pages/HireOnProSapiens";
import CompanyProcess from "./Pages/CompanyProcess";
import CompaniesBlogsResources from "./Pages/CompaniesBlogsResources";
import CompanyReviews from "./Pages/companyReviews";
import CompanyOneprograme from "./Pages/CompanyOneProgramm";
import CompanyRemoteProgram from "./Pages/CompanyRemoteProgram";
import Contact from "./Pages/Contact";
import Openings from "./Pages/openings";
import JobDetails from "./Pages/JobDetails";
import BlogDetail from "./Pages/BlogDetail";

function App() {
  useEffect(() => {
    AOS.init({ duration: 1000 });
  }, []);
  return (
    <Router >
      <div className="App">
        <Header />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<AboutSection />} />
          <Route path="/blog" element={<BlogCards />} />
          <Route path="/recruitment" element={<RecruitmentPage />} />
          <Route
            path="/organizational-development"
            element={<OrganizationPage />}
          />
          <Route
            path="/learning-development"
            element={<LearningDevelopmentPage />}
          />
          <Route path="/hr-outsourcing" element={<HrOutsourcingPage />} />
          <Route path="/jobseekers-blog" element={<JobseekerBlog />} />
          <Route path="/jobseekers-reviews" element={<Testimonials />} />
          <Route path="/jobseekers-1-program" element={<JobseekersProgram />} />
          <Route
            path="/jobseekers-remote-program"
            element={<RemoteProgram />}
          />
          <Route path="/hire-about-prosapiens" element={<HireOnProSapiens />} />
          <Route path="/process" element={<CompanyProcess />} />
          <Route path="/blog-resources" element={<CompaniesBlogsResources />} />
          <Route path="/company-reviews" element={<CompanyReviews />} />
          <Route path="/company-1-program" element={<CompanyOneprograme />} />
          <Route path="/company-remote-p" element={<CompanyRemoteProgram />} />
          <Route
            path="/company-remote-program"
            element={<CompanyRemoteProgram />}
          />
          <Route path="/openings" element={<Openings />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/job-details/:id" element={<JobDetails />} />
          <Route path="/blogs/:id" element={<BlogDetail />} />
        </Routes>
        <Footer />
      </div>
    </Router>
  );
}

export default App;
